/* ══════════════════════════════════════════════════════════════════════════════════════
   L'ATELIER : la personnalisation en plein ecran, sur telephone.

   Adrien, 23/08/2026 : « au clic sur "creer mon affiche" ca ouvre une modale [...] ca s'ouvre
   en grand comme une app mobile, il n'y a plus les menus du site en haut, juste une fleche en
   haut a gauche pour revenir en arriere et un bouton "choisir la taille" en haut a droite [...]
   en bas on a les menus en ligne avec icones comme une app mobile : mise en page, textes,
   couleur de fond, etc. qui ouvre des options ». Puis, le meme jour : « tout le redesign
   demande s'applique uniquement sur mobile ».

   ⛔ CE FICHIER NE DESSINE AUCUNE COMMANDE. Il fabrique une COQUE (barre du haut, scene,
   panneau, onglets) et y DEPLACE les blocs qui vivent deja sur la fiche : l'apercu, les mises
   en page, les polices, les couleurs, les champs de texte, puis les formats, la bordure, le
   cadre et le crochet. Chaque bloc revient a sa place exacte a la fermeture, repere par un
   jalon.
   La raison est celle de la fenetre de taille, apprise le 20/08/2026 : recopier les commandes
   creerait une seconde verite (etat, libelles, champs caches) et c'est toujours la copie qu'on
   ne regarde pas qui vieillit. Ici, le client manipule les VRAIS boutons ; `product.js` n'a
   rien a savoir de cette fenetre.

   ⛔⛔ ET LA COQUE VIT DANS `#pdp-form`. `product.js` moissonne le panier par
   `#pdp-form [name^="properties["]` : sortis du formulaire, la bordure et ses champs
   quitteraient la ligne de panier SANS lever la moindre erreur, et le client paierait une
   option qu'il ne recevrait pas. C'est deja la regle de `murRenduModale`, et elle vaut ici
   pour la meme raison.

   ⚠️ RIEN N'EST OBLIGATOIRE. Si un bloc attendu manque, il est simplement ignore ; si l'apercu
   manque, la fenetre ne s'ouvre pas et la fiche garde son parcours d'avant. Un atelier a
   moitie monte serait pire que pas d'atelier.
   ══════════════════════════════════════════════════════════════════════════════════════ */
(function () {
  "use strict";

  var RACINE = "pa";
  var coque = null;          // la coque, fabriquee une seule fois
  var jalons = [];           // { el, jalon } pour rendre chaque bloc a sa place
  var ecran = "creation";    // "creation" ou "achat"
  var ongletActif = "";
  var ouvreur = null;        // ce qui avait le focus avant l'ouverture

  function $(s, r) { return (r || document).querySelector(s); }
  function mot(cle, repli) {
    var d = $("#perso-atelier-mots");
    var v = d && d.getAttribute("data-" + cle);
    return v || repli;
  }
  /* Le collage designe des CASES, l'affiche personnalisee une PHOTO : deux cles, un seul
     appel. (Adrien, 23/08/2026 : « CLIQUEZ SUR UNE CASE POUR IMPORTER » sur le pele-mele.) */
  function motManquePhoto(repli) {
    var cle = document.querySelector(".pdp--pelemele") ? "case-dabord" : "photo-dabord";
    return mot(cle, repli);
  }
  /* ⛔ LE TELEPHONE SE DEMANDE AU THEME, il ne se redevine pas. `murEstMobile` est deja ce que
     lisent la fenetre de taille et `product.js` pour le meme arbitrage : deux definitions du
     mot « mobile » finiraient par diverger d'un pixel, et un seul des deux chemins basculerait. */
  function surTelephone() {
    return !!(window.murEstMobile && window.murEstMobile());
  }

  function disponible() {
    if (!window.__pdpPerso || window.__pdpPanneau) return false;
    if (!surTelephone()) return false;
    return !!$(".pdp-gallery__wrap") && !!$("#pdp-form");
  }

  /* ---------- les icones, dessinees pour 22 px ---------- */
  var ICONES = {
    photo: '<path d="M4 7h3l1.6-2h6.8L17 7h3v12H4z"/><circle cx="12" cy="13" r="3.4"/>',
    layout: '<rect x="4" y="3" width="16" height="18" rx="1.4"/><rect x="7" y="6" width="10" height="8"/><path d="M8 17h8"/>',
    texte: '<path d="M5 6.5V5h14v1.5"/><path d="M12 5v14"/><path d="M9 19h6"/>',
    fond: '<circle cx="12" cy="12" r="8.2"/><path d="M12 3.8v16.4"/><path d="M3.8 12h16.4"/>',
    /* ⛔ « FORMAT » MONTRE DES FORMATS. C'etait une goutte d'encre, reprise de la palette : elle
       ne dit rien de ce que l'onglet ouvre, et Adrien l'a relevee (« l'image du menu pour
       "format" n'a aucun sens »). Deux rectangles, un debout et un couche : c'est exactement le
       choix qu'il y a derriere. */
    format: '<rect x="3.5" y="2.5" width="8" height="12" rx="1"/><rect x="13.5" y="9.5" width="7" height="5" rx="1"/><path d="M3.5 18.5h17"/>'
  };
  function svg(cle) {
    return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-linecap="round"'
      + ' stroke-linejoin="round" aria-hidden="true" focusable="false">' + (ICONES[cle] || "") + "</svg>";
  }

  /* ⛔ LA TABLE DES ONGLETS EST LA SEULE LISTE. Chaque onglet nomme les blocs de la fiche qu'il
     montre ; il ne s'affiche que si au moins un d'entre eux existe. Une liste ecrite deux fois
     (ici et dans le gabarit) finirait par designer deux ensembles differents. */
  var ONGLETS = [
    /* ⛔ ON EMPRUNTE LE DEPOT LUI-MEME, PAS SON CONTENEUR D'ORIGINE. `product.js` DEPLACE
       `#pdp-upload` dans le bloc d'achat sur telephone (« l'import EST le CTA ») : viser
       `.perso-drop` rapportait donc un conteneur VIDE, et l'onglet « Photo » de la fenetre
       n'offrait plus rien. Mesure du 23/08/2026 dans le Chrome d'Adrien : `.perso-drop` dans la
       fenetre, `#pdp-upload` reste dans `.pdp-buy-actions`, 48 px de haut, sur la fiche.
       ⚠️ LA LECON EST CELLE DES DEUX FAUTES PRECEDENTES : on ne raisonne pas sur l'endroit ou le
       gabarit ECRIT un bloc, mais sur celui ou il se TROUVE au moment ou on le prend. */
    /* ⛔ PAS D'ONGLET « PHOTO » SUR LE PELE-MELE (Adrien, 23/08/2026 : « le bouton "photo" dans le
       menu n'a pas lieu d'etre »). On y ajoute et on y remplace une photo EN TOUCHANT UNE CASE :
       un onglet qui n'offre qu'un bouton en doublon prend une place que l'affiche merite mieux.
       L'affiche personnalisee le garde : elle n'a qu'une case, et son bloc « Changer de photo »
       n'a nulle part ailleurs ou vivre. */
    { cle: "photo",  icone: "photo",  libelle: "onglet-photo", saufPeleMele: true,
      blocs: ["#pdp-upload"], blocsEtat: ["#pdp-photo-block"] },
    /* ⛔ LES DEUX FICHES N'ONT PAS LES MEMES REGLAGES, ET LA TABLE PORTE LES DEUX. L'affiche a
       message a ses mises en page, ses polices et ses fonds ; le pele-mele a ses gabarits, son
       nombre de cases et ses champs de texte, qui vivent dans `#pelemele-zone`. Un onglet ne
       s'affiche que si au moins un de ses blocs existe : chaque fiche montre donc les siens, et
       la table reste la seule liste.
       ⚠️ CE QUI EST DANS `blocsEtat` GARDE SON `hidden` : sur le pele-mele, le nombre de cases,
       le style et les champs de texte paraissent ou non SELON LE GABARIT choisi, et c'est
       `pele-mele.js` qui en decide. Lever ce `hidden` offrirait des reglages qui n'existent pas
       pour la mise en page en cours. */
    /* ⛔ « STYLE » ET « VOTRE NOMBRE » VIVENT AVEC LA MISE EN PAGE (Adrien, 23/08/2026 : « "votre
       style" et "votre nombre" va dans mise en page a droite (ou la place de pour "nombres") de
       nombre de cases aussi »). Ils etaient dans « Texte », ou ils n'ont rien a faire : ils ne
       changent aucun mot, ils changent la FORME de la planche, au meme titre que le nombre de
       cases. Le style du TEXTE (`#pelemele-style-bloc`, libelle « Texte ») reste, lui, dans
       l'onglet Texte : c'est le seul des quatre qui parle vraiment du texte.
       ⚠️ Ils gardent leur `hidden` : c'est `pele-mele.js` qui decide lequel parait selon le
       gabarit, et « Votre nombre » remplace « Nombre de cases » sur le gabarit Nombre, comme il
       le demande, sans qu'aucune regle d'ici n'ait a le savoir. */
    { cle: "layout", icone: "layout", libelle: "onglet-layout",
      blocs: [".perso-text__head", ".perso-text__designs", "#pelemele-zone > .pelemele-bloc:first-of-type"],
      blocsEtat: ["#pelemele-cases-bloc", "#pelemele-decalee-style-bloc",
                  "#pelemele-coeur-style-bloc", "#pelemele-nombre-bloc"] },
    /* ⛔ LES BLOCS DU PELE-MELE SONT ENUMERES, PAS DEVINES. J'en avais nomme trois de memoire ;
       il y en a HUIT (`grep 'id="pelemele-…-bloc"'`), et les deux que j'avais oublies — la police
       et la couleur de fond — sont restes sur la fiche, visibles, apres que j'ai annonce le
       contraire (capture d'Adrien, 23/08/2026, sur `?layout=damier&titre=…`).
       Une liste ecrite de tete mesure ma memoire, pas le gabarit. */
    { cle: "texte",  icone: "texte",  libelle: "onglet-texte",
      blocs: ["#perso-text-plier", ".perso-text__fonts"],
      blocsEtat: ["#pelemele-police-bloc", "#pelemele-style-bloc", "#pelemele-textes-bloc"] },
    { cle: "fond",   icone: "fond",   libelle: "onglet-fond",   blocs: [".perso-text__colors"],
      blocsEtat: ["#pelemele-fond-bloc"] },
    { cle: "format", icone: "format", libelle: "onglet-format", blocs: ["#perso-orient"] }
  ];

  /* ---------- deplacer, et savoir revenir ---------- */
  /* ⛔ UN JALON GARDE LE RANG ENTRE DEUX FRERES. Rendre les blocs par un `appendChild` les
     reposerait tous en fin de colonne, sous le bouton d'achat : la fiche reviendrait dans un
     ordre que personne n'a choisi. C'est la lecon de `murRenduModale`, ecrite le 20/08/2026. */
  function emprunter(sel, hote, etat) {
    var el = $(sel);
    if (!el || jalons.some(function (j) { return j.el === el || j.el.contains(el); })) return null;
    var jalon = document.createComment("atelier:" + sel);
    el.parentNode.insertBefore(jalon, el);
    jalons.push({ el: el, jalon: jalon, hidden: el.hidden });
    /* ⛔ ET LE `hidden` DE LA FICHE NE SUIT PAS, SAUF QUAND IL DIT UN ETAT DU PRODUIT. Sur la
       fiche, le panneau de texte reste cache tant que « Avec texte » n'est pas choisi : ici c'est
       l'onglet qui decide ce qu'on voit, et un `hidden` herite masquerait un onglet entier sans
       que rien ne le dise. Mais « Changer de photo » est cache parce qu'AUCUNE PHOTO N'EXISTE, et
       ce `hidden`-la appartient a `product.js` : le lever affichait une vignette vide et un lien
       qui ne change rien, dans une fenetre ou le client n'a encore rien depose (constate a
       l'ecran le 23/08/2026).
       Il est de toute facon REPOSE tel quel au retour : la fiche se retrouve comme on l'a prise. */
    if (!etat) el.hidden = false;
    /* ⛔ UN BLOC EMPRUNTE SE RECONNAIT, SINON UNE REGLE ECRITE POUR LA FICHE LE SUIT DANS LA
       FENETRE. C'est arrive a « Changer de photo » le 23/08/2026 : masque sur la fiche parce
       qu'il est deja dans la modale, il etait masque DANS la modale par la meme ligne, et
       l'onglet « Photo » n'avait plus rien a montrer apres un import. Le marqueur suit
       l'element, il ne parie pas sur l'endroit ou il se trouve. */
    el.setAttribute("data-pa-emprunte", "");
    /* ⛔ LE LIBELLE COURT, LE TEMPS DE LA FENETRE (Adrien, 23/08/2026 : « remplace "nombre de
       cases" par "cases" »). La colonne d'achat garde sa phrase entiere ; ici le bloc partage sa
       ligne avec le style, et trois mots repoussaient la rangee des pastilles hors de l'ecran.
       ⚠️ LE MOT VIENT DU GABARIT (`data-court`), traduit par le serveur : l'ecrire ici serait du
       francais servi a douze marches. Et l'ancien est mis de cote pour etre REPOSE au retour :
       la fiche doit se retrouver exactement comme on l'a prise. */
    Array.prototype.forEach.call(el.querySelectorAll("[data-court]"), function (m) {
      if (m.hasAttribute("data-long")) return;
      var court = m.getAttribute("data-court");
      if (!court) return;
      m.setAttribute("data-long", m.textContent);
      m.textContent = court;
    });
    hote.appendChild(el);
    return el;
  }
  function toutRendre() {
    /* A l'envers : les blocs rentrent AVANT que la coque disparaisse, sinon elle les emporte. */
    for (var i = jalons.length - 1; i >= 0; i -= 1) {
      var j = jalons[i];
      j.el.removeAttribute("data-pa-emprunte");
      /* Le libelle long revient avec le bloc : la fiche se retrouve comme on l'a prise. */
      Array.prototype.forEach.call(j.el.querySelectorAll("[data-long]"), function (m) {
        m.textContent = m.getAttribute("data-long");
        m.removeAttribute("data-long");
      });
      if (j.jalon.parentNode) j.jalon.parentNode.insertBefore(j.el, j.jalon);
      j.el.hidden = j.hidden;
      if (j.jalon.parentNode) j.jalon.parentNode.removeChild(j.jalon);
    }
    jalons = [];
  }

  /* ---------- la coque ---------- */
  var oeilPanneau = null;
  var oeilTaille = null;
  /* ⛔⛔ LES ONGLETS SE RELISENT SUR UN OBSERVATEUR, PLUS SUR DES MINUTERIES. J'ai essaye 900 ms,
     puis 900 et 2 600 : l'onglet « Photo » du pele-mele restait dans la barre avec un panneau
     vide (mesure du 23/08/2026 : `pdp-upload` a 0 de haut, `pdp-photo-block` cache, onglet
     toujours affiche). Deviner QUAND un autre script a fini de ranger ses blocs, c'est parier ;
     l'observateur, lui, le SAIT.
     ⚠️ ON N'OBSERVE QUE LE PANNEAU, et `majOnglets` n'ecrit que sur les ONGLETS, qui sont hors du
     panneau : la boucle est impossible par construction. */
  function observePanneau() {
    if (!window.MutationObserver || !coque) return;
    var pn = $("[data-pa-panneau]", coque);
    if (!pn) return;
    if (oeilPanneau) oeilPanneau.disconnect();
    var prevu = false;
    oeilPanneau = new MutationObserver(function () {
      if (prevu) return;
      prevu = true;
      requestAnimationFrame(function () { prevu = false; suivreModeTexte(); majOnglets(); });
    });
    oeilPanneau.observe(pn, { subtree: true, childList: true,
      attributes: true, attributeFilter: ["hidden", "style", "class", "aria-pressed"] });
    /* ⛔⛔ ET LA TAILLE AUSSI, PARCE QU'UN BLOC PEUT DISPARAITRE SANS QU'AUCUN ATTRIBUT NE BOUGE.
       Sur le pele-mele, `#pdp-upload` passe de 48 px a 0 par une REGLE de feuille declenchee
       ailleurs que dans le panneau : l'observateur de mutations n'en voit rien, et l'onglet
       « Photo » restait affiche sur un panneau vide (mesure du 23/08/2026, apres l'observateur
       de mutations : depot a 0, onglet toujours la).
       Or `majOnglets` decide justement sur la HAUTEUR. On observe donc ce dont depend la
       decision, pas ce qu'on croit en etre la cause.
       ⚠️ AUCUNE BOUCLE : ce rappel n'appelle QUE `majOnglets`, qui n'ecrit que sur les onglets,
       hors du panneau. Il ne touche a rien de ce qu'il observe. */
    if (oeilTaille) oeilTaille.disconnect();
    if (window.ResizeObserver) {
      var prevuT = false;
      oeilTaille = new ResizeObserver(function () {
        if (prevuT) return;
        prevuT = true;
        requestAnimationFrame(function () { prevuT = false; majOnglets(); });
      });
      var groupes = pn.querySelectorAll("[data-pa-groupe]");
      for (var i = 0; i < groupes.length; i += 1) {
        for (var j = 0; j < groupes[i].children.length; j += 1) {
          try { oeilTaille.observe(groupes[i].children[j]); } catch (e) { /* rien */ }
        }
      }
    }
  }

  var oeilScene = null;
  /* ⛔⛔ LA SCENE EST RELUE DES QU'ELLE CHANGE DE TAILLE. Le panneau d'options grandit quand on
     ouvre « Mise en page » ou « Texte », donc la scene retrecit — mais l'affiche gardait la taille
     en pixels mesuree A L'OUVERTURE, et debordait sous le panneau : « on ne voit pas ce qu'on
     modifie » (Adrien, 23/08/2026). C'est le revers exact du passage aux pixels : ce qui ne se
     deduit plus doit se remesurer.
     ⚠️ AUCUNE BOUCLE : on observe la SCENE, dont la hauteur est fixee par la grille et non par son
     contenu (`min-height:0`, `overflow:hidden`), et `mesureScene` n'ecrit que sur la coque, et
     seulement si la valeur change. */
  function observeScene() {
    if (!window.ResizeObserver || !coque) return;
    var sc = $("[data-pa-scene]", coque);
    if (!sc) return;
    if (oeilScene) oeilScene.disconnect();
    oeilScene = new ResizeObserver(function () { mesureScene(); });
    try { oeilScene.observe(sc); } catch (e) { oeilScene = null; }
  }

  function fabrique() {
    if (coque) return coque;
    var d = document.createElement("div");
    d.className = RACINE;
    d.id = "perso-atelier";
    d.setAttribute("role", "dialog");
    d.setAttribute("aria-modal", "true");
    d.innerHTML =
      '<div class="pa__top">'
      + '<button type="button" class="pa__retour" data-pa-retour aria-label="' + mot("retour", "Retour") + '">'
      + '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M15 4.5 7.5 12l7.5 7.5"/></svg>'
      + "</button>"
      + '<span class="pa__titre" data-pa-titre></span>'
      + '<button type="button" class="pa__suite" data-pa-suite></button>'
      + "</div>"
      + '<div class="pa__scene" data-pa-scene></div>'
      /* ⛔ L'INVITATION SOUS L'AFFICHE (Adrien, 23/08/2026 : « le bouton "cliquez sur une case
         pour importer" va en bas de l'image placeholder de la modale aussi, puis disparait quand
         au moins une image a ete importee »). Le bouton du haut dit deja le geste, mais il est
         loin des cases : sous l'affiche, le mot et la cible sont dans le meme regard. */
      + '<button type="button" class="pa__inviter sans" data-pa-inviter hidden></button>'
      + '<div class="pa__panneau" data-pa-panneau></div>'
      + '<div class="pa__tabs" role="tablist" data-pa-tabs></div>';
    /* ⛔⛔ DANS LE FORMULAIRE, PAS DANS LE CORPS : voir l'entete. La position est `fixed`, donc
       le parent ne change rien a l'ecran ; il change tout au panier. */
    $("#pdp-form").appendChild(d);
    d.addEventListener("click", function (e) {
      var t = e.target;
      if (!t || !t.closest) return;
      if (t.closest("[data-pa-retour]")) { reculer(); return; }
      if (t.closest("[data-pa-suite]")) { avancer(); return; }
      if (t.closest("[data-pa-inviter]")) { designeLaCase(); return; }
      var onglet = t.closest("[data-pa-onglet]");
      if (onglet) { montreOnglet(onglet.getAttribute("data-pa-onglet")); return; }
      /* Un clic dans le panneau a pu changer le gabarit, donc ce que les onglets ont a montrer.
         Relu a la image suivante : les scripts de la fiche posent leurs `hidden` d'abord. */
      if (t.closest("[data-pa-panneau]")) {
        requestAnimationFrame(function () { suivreModeTexte(); majOnglets(); });
        /* ⛔ ET LA FORME PEUT AVOIR CHANGE SANS QUE LA SCENE BOUGE : « Paysage » retourne le
           rapport, pas la place disponible. L'observateur de taille ne le verrait pas. Deux
           passes : la premiere suffit presque toujours, la seconde rattrape une bascule que la
           fiche pose un tour plus tard. */
        requestAnimationFrame(mesureScene);
        setTimeout(mesureScene, 260);
      }
    });
    /* ⛔ ET UN IMPORT CHANGE AUSSI CE QUE LES ONGLETS ONT A MONTRER. Il n'arrive pas par un clic
       dans le panneau mais par le champ de fichier : sans cet ecouteur, un onglet vide par
       l'import restait affiche, et un onglet rempli par lui restait cache. */
    var fichier = document.getElementById("pdp-file");
    /* ⛔ DEUX PASSES APRES UN IMPORT, PAS UNE. `pele-mele.js` range sa pile de photos en plusieurs
       temps : a 900 ms l'onglet « Photo » se lisait encore comme rempli alors que son bouton
       venait de passer a zero de haut, et il restait affiche sur un panneau vide (mesure du
       23/08/2026 : depot a 0, onglet toujours la). La seconde passe rattrape ce que la premiere
       a lu trop tot. */
    var relire = function () {
      majOnglets();
      if (ecran === "creation") majSuite();
    };
    if (fichier) fichier.addEventListener("change", function () {
      setTimeout(relire, 900);
      setTimeout(relire, 2600);
    });
    coque = d;
    return d;
  }

  /* Le mot du bouton et le titre disent la meme etape : une seule fonction les ecrit.
     ⛔ ET LE TITRE S'EFFACE TANT QU'IL MANQUE UNE PHOTO. « Cliquez sur une case pour importer »
     est bien plus long que « Choisir la taille » : la barre du haut serrait alors le titre
     jusqu'a « VO... » (mesure du 23/08/2026, WebKit iPhone 390 px). Un titre elide a deux
     lettres se lit comme un defaut, et il ne dit rien que le bouton ne dise deja. */
  /* ⛔ UNE FLECHE A DROITE DU MOT (Adrien, 23/08/2026 : « bouton "choisir la taille" des modales
     des 2 produits personnalises, ajoute une icone fleche a droite du texte du bouton »). Elle
     dit que ce bouton FAIT AVANCER, la ou celui d'a cote fait reculer.
     ⚠️ LE MOT VIT DANS UN `span`, ET LE BOUTON SE REECRIT EN ENTIER A CHAQUE FOIS. Poser le mot
     par `textContent` sur le bouton emporterait la fleche avec lui, sans erreur : c'est ce que
     fait encore l'ecran d'achat, et c'est voulu — « Ajouter au panier » n'avance pas, il conclut.
     ⚠️ `aria-hidden` ET AUCUN TEXTE : la fleche ne se lit pas, elle se voit. Un lecteur d'ecran
     qui annoncerait « Choisir la taille fleche droite » lirait un dessin. */
  var FLECHE = '<svg class="pa__fleche" viewBox="0 0 24 24" fill="none" stroke="currentColor"'
    + ' stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">'
    + '<path d="M5 12h13"/><path d="m12.5 5.5 6.5 6.5-6.5 6.5"/></svg>';
  function ecrisSuite(b, texte, avecFleche) {
    if (!b) return;
    b.textContent = "";
    var m = document.createElement("span");
    m.className = "pa__suite-mot";
    m.textContent = texte;
    b.appendChild(m);
    if (avecFleche) b.insertAdjacentHTML("beforeend", FLECHE);
  }
  function majSuite(hote) {
    var d = hote || coque;
    if (!d) return;
    var b = $("[data-pa-suite]", d);
    if (!b) return;
    var ok = aUnePhoto();
    var invite = motManquePhoto(mot("suite-taille", "Choisir la taille"));
    /* ⛔⛔ L'INVITATION N'EXISTE QU'A UN SEUL ENDROIT, ET C'EST SOUS L'AFFICHE (Adrien,
       23/08/2026 : « ce bouton ne doit pas etre en double, seulement en bas »). Elle etait
       ecrite sur les DEUX boutons pour qu'ils ne divergent pas ; la vraie reponse au risque de
       divergence est qu'il n'y en ait qu'un. Le bouton du haut fait AVANCER : tant qu'il n'y a
       pas de photo, il n'y a nulle part ou avancer, et un bouton qui refuse ne vaut pas la
       place qu'il prend au-dessus de l'affiche. */
    ecrisSuite(b, mot("suite-taille", "Choisir la taille"), true);
    b.hidden = !ok;
    d.classList.toggle("pa-sans-photo", !ok);
    var inv = $("[data-pa-inviter]", d);
    if (inv) { inv.textContent = invite; inv.hidden = ok; }
  }

  /* ---------- l'ecran de creation ---------- */
  function monteCreation() {
    var d = fabrique();
    d.classList.remove("pa--achat");
    $("[data-pa-titre]", d).textContent = mot("titre-creation", "");
    /* Le mot dit l'etape possible : sans photo, il n'y a pas de taille a choisir. */
    majSuite(d);
    emprunter(".pdp-gallery__wrap", $("[data-pa-scene]", d));

    var tabs = $("[data-pa-tabs]", d);
    var panneau = $("[data-pa-panneau]", d);
    tabs.innerHTML = "";
    panneau.innerHTML = "";
    var premier = "";
    var estPeleMele = !!document.querySelector(".pdp--pelemele");
    ONGLETS.forEach(function (o) {
      if (o.saufPeleMele && estPeleMele) return;
      var groupe = document.createElement("div");
      groupe.className = "pa__groupe";
      groupe.setAttribute("data-pa-groupe", o.cle);
      groupe.hidden = true;
      panneau.appendChild(groupe);
      var pris = 0;
      o.blocs.forEach(function (sel) { if (emprunter(sel, groupe)) pris += 1; });
      /* Ceux-la gardent le `hidden` que leur a pose la fiche : il dit un etat, pas une etape.
         Ils comptent tout de meme pour l'existence de l'onglet : sur le pele-mele, TOUS les
         reglages de texte sont des blocs d'etat, et sans ce compte l'onglet « Texte » n'aurait
         jamais existe la-bas. */
      (o.blocsEtat || []).forEach(function (sel) { if (emprunter(sel, groupe, true)) pris += 1; });
      /* Un onglet sans contenu ne s'affiche pas : il promettrait un choix qui n'existe pas
         sur cette fiche (le pele-mele n'a pas les memes blocs que l'affiche a message). */
      if (!pris) { panneau.removeChild(groupe); return; }
      var b = document.createElement("button");
      b.type = "button";
      b.className = "pa__tab";
      b.setAttribute("role", "tab");
      b.setAttribute("data-pa-onglet", o.cle);
      b.setAttribute("aria-selected", "false");
      b.innerHTML = svg(o.icone) + "<span>" + mot(o.libelle, o.cle) + "</span>";
      tabs.appendChild(b);
      if (!premier) premier = o.cle;
    });
    suivreModeTexte();
    montreOnglet(ongletActif && $('[data-pa-groupe="' + ongletActif + '"]', d) ? ongletActif : premier);
    majOnglets();
    mesureScene();
    requestAnimationFrame(mesureScene);
    observeScene();
    observePanneau();
  }

  /* ⛔⛔ LA HAUTEUR DE LA SCENE SE MESURE ET S'ECRIT EN PIXELS. `height:100%` dans la scene ne se
     resout que si chaque ancetre a une hauteur definie ; la scene est une piste `1fr` de grille,
     et Safari iOS ne la traite pas comme definie pour ses descendants. Toute la chaine tombait a
     zero : l'affiche existait, mesurait 0, et la fenetre s'ouvrait sur du creme (capture d'iPhone
     du 23/08/2026). Un nombre de pixels se resout partout.
     ⚠️ AUCUNE BOUCLE : on lit la scene et on ecrit sur la COQUE, jamais sur la scene elle-meme. */
  function mesureScene() {
    if (!coque) return;
    var sc = $("[data-pa-scene]", coque);
    if (!sc) return;
    var r = sc.getBoundingClientRect();
    var cs = getComputedStyle(sc);
    var dispo = {
      l: Math.round(r.width - (parseFloat(cs.paddingLeft) || 0) - (parseFloat(cs.paddingRight) || 0)),
      h: Math.round(r.height - (parseFloat(cs.paddingTop) || 0) - (parseFloat(cs.paddingBottom) || 0))
    };
    if (!(dispo.l > 0 && dispo.h > 0)) return;
    /* ⛔⛔ LES DEUX DIMENSIONS SONT CALCULEES ICI, EN PIXELS. La hauteur seule ne suffisait pas :
       la largeur restait deduite d'`aspect-ratio` sur `.pdp-frame__inner`, et il suffit qu'UN
       maillon de cette deduction ne se fasse pas pour que l'affiche mesure zero et que la fenetre
       s'ouvre sur du vide. C'est ce qu'Adrien voit sur son iPhone alors que Chrome et WebKit de
       bureau resolvent la meme chaine. On ne suppose donc plus rien du moteur : la place
       disponible est mesuree, le rapport est LU, et les deux cotes sont ecrits en pixels.
       ⚠️ LE RAPPORT SE LIT, IL NE S'INVENTE PAS : `--art-ratio` est pose par le gabarit sur la
       galerie (0,6923 en portrait, son inverse en paysage), et le repli n'est la que pour le jour
       ou la variable disparaitrait. */
    /* ⛔⛔ LE RAPPORT SE LIT SUR `.pdp-frame__inner`, ET D'ABORD SUR SON `aspect-ratio` DECLARE.
       C'est lui que le theme retourne quand la cliente choisit « Paysage ». Ma premiere version
       lisait `--art-ratio` sur `.pdp-gallery__wrap` : cette variable est posee par le gabarit sur
       `.pdp-gallery`, le PARENT, qui reste sur la fiche pendant que le wrap part dans la fenetre.
       Le wrap n'en heritait donc plus, le repli de 0,6923 s'appliquait toujours, et « Paysage »
       ne retournait rien (Adrien, 23/08/2026 : mesure 380x581 en portrait, 394x581 en paysage —
       la boite ne bougeait pas).
       ⚠️ ET ON LIT LA PROPRIETE DECLAREE, PAS LA BOITE : je force desormais `width` et `height` en
       pixels sur cet element, donc sa taille rendue ne dit plus rien de sa forme. `aspect-ratio`
       reste, lui, ce que la feuille a decide. */
    var rapport = 0;
    var inner = sc.querySelector(".pdp-frame__inner");
    var ar = inner ? getComputedStyle(inner).aspectRatio : "";
    var m = /([\d.]+)\s*\/\s*([\d.]+)/.exec(ar || "");
    if (m) rapport = parseFloat(m[1]) / parseFloat(m[2]);
    if (!(rapport > 0)) {
      var gal = document.querySelector(".pdp-gallery");
      rapport = parseFloat(gal ? getComputedStyle(gal).getPropertyValue("--art-ratio") : "");
      if (gal && gal.getAttribute("data-paysage") === "true" && rapport > 0) rapport = 1 / rapport;
    }
    if (!(rapport > 0)) rapport = 0.6923;
    /* ⛔ LA MOULURE S'AJOUTE AUTOUR DE LA FEUILLE : elle est une BORDURE de `#pdp-frame`, donc
       elle occupe de la place en plus. Sans la retrancher, l'affiche depasse de son epaisseur des
       quatre cotes, et le cadre se fait rogner par la scene. */
    var cadre = sc.querySelector("#pdp-frame");
    var ep = cadre ? (parseFloat(getComputedStyle(cadre).borderTopWidth) || 0) : 0;
    dispo.l = Math.max(0, dispo.l - 2 * ep);
    dispo.h = Math.max(0, dispo.h - 2 * ep);
    if (!(dispo.l > 0 && dispo.h > 0)) return;
    /* La plus grande affiche qui tienne dans la place, au rapport lu. */
    var l = dispo.l;
    var h = Math.round(l / rapport);
    if (h > dispo.h) { h = dispo.h; l = Math.round(h * rapport); }
    /* ⚠️ ON N'ECRIT QUE SI LA VALEUR CHANGE : l'observateur de taille relit la scene apres chaque
       ecriture, et une ecriture inutile suffirait a l'entretenir indefiniment. */
    if (coque.style.getPropertyValue("--pa-h") !== h + "px") coque.style.setProperty("--pa-h", h + "px");
    if (coque.style.getPropertyValue("--pa-l") !== l + "px") coque.style.setProperty("--pa-l", l + "px");
  }

  function montreOnglet(cle) {
    if (!coque) return;
    ongletActif = cle || "";
    var groupes = coque.querySelectorAll("[data-pa-groupe]");
    var i;
    for (i = 0; i < groupes.length; i += 1) {
      groupes[i].hidden = groupes[i].getAttribute("data-pa-groupe") !== ongletActif;
    }
    var tabs = coque.querySelectorAll("[data-pa-onglet]");
    for (i = 0; i < tabs.length; i += 1) {
      tabs[i].setAttribute("aria-selected",
        tabs[i].getAttribute("data-pa-onglet") === ongletActif ? "true" : "false");
    }
    var panneau = $("[data-pa-panneau]", coque);
    if (panneau) panneau.hidden = !ongletActif;
  }

  /* ⛔ UN ONGLET DONT LE PANNEAU EST VIDE NE S'AFFICHE PAS. Sur le pele-mele, le nombre de cases,
     le style et les champs de texte paraissent SELON LE GABARIT : un gabarit sans texte laissait
     un onglet « Texte » qui n'ouvrait rien. Un onglet qui ouvre le vide vaut moins que pas
     d'onglet du tout.
     ⚠️ RELU APRES CHAQUE CLIC DANS LA FENETRE, parce que c'est un clic qui change le gabarit, et
     donc ce que chaque onglet a a montrer. */
  /* ⛔⛔ EN « PHOTO SEULE », IL N'Y A RIEN A METTRE EN PAGE (Adrien, 23/08/2026 : « les options de
     mise en page s'affichent quand on est sur "photo seule" alors qu'il n'y a pas de mise en page
     possible »). Sur la fiche, le theme cache tout le panneau de texte tant que le mode est
     « Photo seule » ; la fenetre en emprunte les ENFANTS, donc ce `hidden` la ne les suit pas, et
     j'avais de toute facon efface le leur pour que les onglets decident.
     C'est donc a la fenetre de relire le mode. Les quatre blocs qui n'existent que pour le texte
     — mises en page, polices, fond, saisie — suivent l'etat du selecteur, et `majOnglets` efface
     ensuite les onglets devenus vides : en « Photo seule » il ne reste que Photo, Mise en page
     (le seul selecteur) et Format.
     ⚠️ LA COULEUR DE FOND RESTE AU THEME QUAND LE TEXTE EST LA : il la cache lui-meme sur les
     mises en page « Sur la photo », qui n'ont pas de passe-partout. Deux decisions sur le meme
     `hidden` se contrediraient ; on ne prend la main que pour le fermer. */
  function modeTexteActif() {
    var off = document.querySelector('.pa [data-perso-text-mode="off"]');
    if (!off) return true;             /* pas de selecteur : rien a suivre (pele-mele) */
    return off.getAttribute("aria-pressed") !== "true";
  }
  function suivreModeTexte() {
    if (!coque) return;
    var avecTexte = modeTexteActif();
    /* ⛔⛔ ET L'ETAT SE POSE AUSSI EN CLASSE, POUR QUE LA FEUILLE LE TIENNE. Les `hidden` ci-dessous
       ne valent qu'a l'instant ou cette fonction passe ; si un autre script rouvre un bloc, ou si
       la fonction n'a pas encore tourne, les mises en page reparaissent en « Photo seule »
       (Adrien, 23/08/2026 : « mets une condition qui masque les options de mise en page quand
       "photo seule" est cochee »). Une regle de feuille, elle, est vraie en permanence. */
    coque.classList.toggle("pa-sans-texte", !avecTexte);
    [".perso-text__designs", ".perso-text__fonts", "#perso-text-plier"].forEach(function (sel) {
      var el = coque.querySelector(sel);
      if (el) el.hidden = !avecTexte;
    });
    /* ⛔⛔ ET ELLE REVIENT QUAND LE TEXTE REVIENT. Je ne savais que la fermer : en repassant de
       « Photo seule » a « Avec texte », l'onglet « Fond » ne reparaissait jamais, et Adrien l'a
       lu comme la disparition du choix de texte (23/08/2026). Le theme ne la rouvre qu'au
       PROCHAIN changement de mise en page, ce qui peut ne jamais arriver.
       ⚠️ ON REPREND SA REGLE, MOT POUR MOT : « Sur la photo » et « Sur la photo, en bas » n'ont
       pas de passe-partout, donc pas de couleur de fond. La lire ici plutot que de l'inventer :
       une seconde table de mises en page finirait par diverger de la sienne. */
    var fonds = coque.querySelector(".perso-text__colors");
    if (fonds) {
      var inner = coque.querySelector(".pdp-frame__inner");
      var design = inner ? inner.getAttribute("data-perso-design") : "";
      var sansFond = design === "voile" || design === "voile-bas";
      fonds.hidden = !avecTexte || sansFond;
    }
  }

  function majOnglets() {
    if (!coque) return;
    var tabs = coque.querySelectorAll("[data-pa-onglet]");
    var visibles = [];
    for (var i = 0; i < tabs.length; i += 1) {
      var cle = tabs[i].getAttribute("data-pa-onglet");
      var g = $('[data-pa-groupe="' + cle + '"]', coque);
      var utile = false;
      var groupeVisible = !!g && !g.hidden;
      if (g) {
        for (var j = 0; j < g.children.length; j += 1) {
          /* ⛔⛔ « UTILE » SE MESURE, IL NE SE DEDUIT PAS DE `hidden`. Cette boucle ne regardait
             que l'attribut : sur le pele-mele, `#pdp-upload` reste `hidden = false` apres
             l'import et c'est une REGLE DE FEUILLE qui le passe a `display:none`. L'onglet
             « Photo » comptait donc un enfant « visible » de zero pixel de haut, et restait
             affiche sur un panneau vide.
             J'ai essaye trois fois de corriger ce defaut ailleurs — deux minuteries, un
             observateur de mutations, un observateur de taille — en ecrivant a chaque fois que
             la decision se prenait sur la hauteur. Elle ne s'y prenait pas. C'est la seule ligne
             qui comptait, et je ne l'avais pas relue. */
          /* ⛔⛔ ET LA MESURE NE PEUT PAS ETRE LA HAUTEUR : un groupe qui n'est pas l'onglet
             ouvert est lui-meme masque, donc TOUS ses enfants rendent zero. En passant a la
             hauteur, j'ai fait disparaitre quatre onglets sur cinq (mesure : PERSO n'en gardait
             qu'un, le pele-mele aucun). Le defaut d'apres etait pire que celui d'avant.
             Ce qu'on veut savoir, c'est si l'enfant serait visible SI le groupe l'etait. Le
             `display` PROPRE d'un element repond exactement a cela : il ne depend pas de celui de
             ses ancetres. `hidden` seul ne suffisait pas — une regle de feuille peut poser
             `display:none` sans y toucher, et c'est le cas du bouton d'import du pele-mele. */
          /* ⛔⛔ ON NE MESURE QUE CE QU'ON PEUT MESURER. Un groupe qui n'est pas l'onglet ouvert
             est lui-meme masque : la question « cet enfant serait-il visible ? » n'a alors pas de
             reponse fiable — j'ai essaye la hauteur (tous a zero, quatre onglets sur cinq
             disparus) puis le `display` propre (une regle en `:has()` le met a `none` sans que
             rien ne permette de la retrouver, et « Format » disparaissait a son tour).
             Pour le groupe VISIBLE, on mesure : c'est le seul cas qui comptait, puisque l'onglet
             « Photo » du pele-mele est ouvert quand son bouton d'import s'efface. Pour les
             autres, on s'en tient a l'attribut, qui ne ment pas sur ce qu'il dit. Une mesure
             impossible ne se remplace pas par une mesure fausse. */
          var enfant = g.children[j];
          if (enfant.hidden) continue;
          if (groupeVisible && getComputedStyle(enfant).display === "none") continue;
          utile = true; break;
        }
      }
      tabs[i].hidden = !utile;
      if (utile) visibles.push(cle);
    }
    /* Si l'onglet ouvert vient de se vider, on bascule sur le premier qui reste. */
    if (visibles.length && visibles.indexOf(ongletActif) < 0) montreOnglet(visibles[0]);
  }

  /* ---------- l'ecran d'achat ---------- */
  function monteAchat() {
    var d = fabrique();
    d.classList.add("pa--achat");
    $("[data-pa-titre]", d).textContent = mot("titre-achat", "");
    /* ⛔ ET IL REDEVIENT VISIBLE : l'ecran de creation a pu le masquer faute de photo, et rien
       ne le rouvrait au passage a l'achat. Sans cette ligne, l'ecran d'achat n'aurait plus de
       bouton pour ajouter au panier. */
    var bs = $("[data-pa-suite]", d);
    bs.hidden = false;
    ecrisSuite(bs, mot("suite-panier", "Ajouter au panier"), false);
    /* ⛔ L'AFFICHE RESTE SOUS LES YEUX AU MOMENT DE CHOISIR LA TAILLE. Le passage d'ecran rend
       TOUS les blocs a la fiche avant de remonter le suivant : sans cette reprise, la scene de
       l'ecran d'achat restait vide, et le client choisissait un format sans plus voir ce qu'il
       achete. C'est precisement ce que la fenetre existe pour eviter. */
    emprunter(".pdp-gallery__wrap", $("[data-pa-scene]", d));
    var panneau = $("[data-pa-panneau]", d);
    panneau.hidden = false;
    panneau.innerHTML = "";
    $("[data-pa-tabs]", d).innerHTML = "";
    var groupe = document.createElement("div");
    groupe.className = "pa__groupe";
    groupe.setAttribute("data-pa-groupe", "achat");
    panneau.appendChild(groupe);
    /* ⛔ LA LISTE DES BLOCS D'ACHAT VIT DANS `global.js`, UNE SEULE FOIS pour les trois
       configurateurs. La recopier ici en ferait une quatrieme, et c'est celle qu'on ne
       regarde pas qui oublierait la bordure. */
    /* ⛔⛔ `[data-apres-format]` GARDE SON `hidden` : c'est LUI qui dit « une taille a ete
       choisie » (Adrien, 23/08/2026 : « les options doivent etre visibles uniquement quand on a
       clique sur un format »). En le levant comme les autres, la fenetre offrait la bordure, le
       cadre et le crochet avant meme qu'un format existe — et ces options se calculent SUR le
       format. Le theme le montre et le cache deja tout seul ; on ne fait que ne plus l'en
       empecher. */
    (window.murCommandesAchat || []).forEach(function (sel) {
      emprunter(sel, groupe, sel === "[data-apres-format]");
    });
    emprunter(".pdp-buy-actions > .pdp-qty-sel", groupe);
   mesureScene();
    requestAnimationFrame(mesureScene);
    observeScene();
    observePanneau();
  }

  /* ---------- la navigation ---------- */
  /* ⛔⛔ SANS PHOTO, LE BOUTON DESIGNE LA CASE AU LIEU DE REFUSER (Adrien, 23/08/2026 : « quand
     aucune photo n'a ete importee, le CTA doit etre "cliquez sur une photo pour importer" et ca
     met un highlight autour de chaque case de photo, comme pour les formats sur les pages
     produit collection »). C'est la regle deja retenue pour les tailles : un bouton qui refuse
     sans rien apprendre laisse le client chercher ; un bouton qui MONTRE ou cliquer termine le
     geste. On reprend la classe du theme, `pdp-upload--ask`, pas une seconde animation. */
  function aUnePhoto() {
    return !!document.querySelector(".pdp--perso-has-photo");
  }
  function designeLaCase() {
    if (!document.querySelector(".pdp--pelemele")) {
      var fichier = document.getElementById("pdp-file");
      if (fichier) { fichier.click(); return; }
    }
    /* Sur le collage, CHAQUE case a son anneau, et c'est `pele-mele.js` qui les peint : lui seul
       sait ou elles tombent, gabarit par gabarit. Ailleurs il n'y a qu'un emplacement, et c'est
       la carte entiere qui clignote. */
    var parCase = window.__pelemeleDesigneCases ? window.__pelemeleDesigneCases() : 0;
    var cases = (!parCase && coque)
      ? coque.querySelectorAll("#pdp-placeholder, .pa__scene canvas, .pa__scene #pdp-stage") : [];
    for (var i = 0; i < cases.length; i += 1) {
      (function (el) {
        el.classList.remove("pdp-upload--ask");
        /* Relancer une animation demande de la laisser retomber, mais SANS attendre une image :
           une fenetre native qui prend le focus suspend les `requestAnimationFrame` de l'onglet,
           et le clignotement n'arrivait alors jamais (mesure du 23/08/2026, compteur de rAF reste
           a zero pendant que la temporisation tirait). Lire `offsetWidth` force le meme retour a
           zero, tout de suite, sans dependre d'une image a venir. */
        void el.offsetWidth;
        el.classList.add("pdp-upload--ask");
        setTimeout(function () { el.classList.remove("pdp-upload--ask"); }, 1600);
      }(cases[i]));
    }
    var photo = coque && [...coque.querySelectorAll("[data-pa-onglet]")].find(function (b) {
      return b.getAttribute("data-pa-onglet") === "photo" && !b.hidden;
    });
    if (photo) montreOnglet("photo");
  }

  function avancer() {
    if (ecran === "creation" && !aUnePhoto()) { designeLaCase(); return; }
    if (ecran === "creation") { rendreEtMonter("achat"); return; }
    /* ⛔ UN SEUL CHEMIN VERS LE PANIER. `product.js` expose sa fonction d'ajout : elle moissonne
       le formulaire, verifie la taille, envoie la photo si besoin. En ecrire une seconde ici
       serait une deuxieme porte vers la caisse, et celle-la n'aurait pas les gardes de l'autre. */
    if (typeof window.__persoAjouter === "function") window.__persoAjouter();
    /* ⛔⛔ ET LA FENETRE S'EFFACE QUAND LE PANIER S'OUVRE (Adrien, 23/08/2026 : « le bouton
       "ajouter au panier" ne fait rien, ca ajoute au panier en fond mais ca ne quitte pas la
       modale, le client n'est au courant de rien »). L'ajout marchait, son resultat s'affichait
       DERRIERE la fenetre : rien ne bougeait a l'ecran, donc rien n'avait eu lieu pour le client.
       ⚠️ ON NE FERME PAS AVANT D'AVOIR LA PREUVE. `add()` est asynchrone — il envoie la photo,
       verifie la taille, peut refuser. Fermer tout de suite emporterait un message d'erreur que
       personne n'aurait lu, et rendrait les blocs a la fiche pendant que la moisson les lit
       encore. On attend le signe du panier, et on renonce au bout de dix secondes plutot que de
       fermer sur une supposition. */
    var depart = Date.now();
    var oeil = setInterval(function () {
      var ouvert = document.body.classList.contains("cart-open")
        || !!document.querySelector(".cart-drawer.is-open, .drawer--cart.is-open, #cart-drawer[open]");
      if (ouvert) { clearInterval(oeil); fermer(); return; }
      if (Date.now() - depart > 10000) clearInterval(oeil);
    }, 200);
  }
  function reculer() {
    if (ecran === "achat") { rendreEtMonter("creation"); return; }
    fermer();
  }
  function rendreEtMonter(vers) {
    toutRendre();
    ecran = vers;
    if (vers === "achat") monteAchat(); else monteCreation();
  }

  function ouvrir() {
    if (!disponible()) return false;
    if (coque && coque.classList.contains("est-ouvert")) return true;
    ouvreur = document.activeElement;
    ecran = "creation";
    fabrique();
    monteCreation();
    coque.classList.add("est-ouvert");
    document.documentElement.classList.add("pa-ouvert");
    var x = $("[data-pa-retour]", coque);
    if (x) x.focus();
    return true;
  }
  function fermer() {
    if (!coque || !coque.classList.contains("est-ouvert")) return;
    toutRendre();
    coque.classList.remove("est-ouvert");
    coque.classList.remove("pa--achat");
    document.documentElement.classList.remove("pa-ouvert");
    ecran = "creation";
    if (ouvreur && ouvreur.focus) ouvreur.focus();
    ouvreur = null;
  }

  /* ⛔ LE MODE SE RELIT AU CLIC SUR SON SELECTEUR, en capture sur le document : l'ecouteur du
     panneau passe apres celui de `product.js`, et un rappel a l'image suivante suffisait tant que
     rien d'autre ne repeignait. Ici on ne depend plus de l'ordre. */
  document.addEventListener("click", function (e) {
    if (!e.target || !e.target.closest) return;
    if (!e.target.closest("[data-perso-text-mode]")) return;
    requestAnimationFrame(function () { suivreModeTexte(); majOnglets(); });
    setTimeout(function () { suivreModeTexte(); majOnglets(); }, 240);
  }, true);

  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape" && coque && coque.classList.contains("est-ouvert")) reculer();
  });
  /* ⛔ ET UNE ROTATION VERS LA VUE LARGE REND LA FICHE. La feuille masque deja la coque au-dela
     de 900 px ; sans ce retour, les blocs empruntes resteraient prisonniers d'un conteneur
     invisible et la fiche serait vide de ses options, en production, sans erreur. */
  window.addEventListener("resize", function () {
    if (coque && coque.classList.contains("est-ouvert") && !surTelephone()) { fermer(); return; }
    mesureScene();
  });
  window.addEventListener("orientationchange", function () { requestAnimationFrame(mesureScene); });

  /* ---------- le CTA de la fiche ---------- */
  /* ⛔ C'EST LE SCRIPT QUI MONTRE LE BOUTON, PAS LE GABARIT. Rendu cache, il n'apparait que la ou
     l'atelier peut reellement s'ouvrir. Sinon un client sur ordinateur, sur un panneau, ou sur une
     fiche a laquelle il manque l'apercu, verrait « Creer mon affiche » et un clic sans effet.
     ⚠️ ET LE CHEMIN D'IMPORT D'ORIGINE NE SE FERME QUE QUAND LE NOUVEAU EST OUVERT : `.perso-drop`
     n'est retiree de la page que si le bouton, lui, est bien en place. */
  function armeCta() {
    var cta = $("#perso-atelier-cta");
    if (!cta) return;
    var ok = disponible();
    cta.hidden = !ok;
    document.documentElement.classList.toggle("pa-dispo", ok);
    /* ⛔ ET LA BARRE EPINGLEE SE MET AU MEME MOT. Elle disait « Importer ma photo » pendant que
       ce bouton dit « Creer mon affiche », alors que les deux ouvrent la meme fenetre : deux
       promesses pour un seul geste, dont l'une renvoyait au parcours d'avant la refonte. Le
       libelle reste calcule par `product.js`, a un seul endroit ; on lui dit seulement que
       l'etat a change. */
    if (window.__pdpSyncCta) window.__pdpSyncCta();
  }
  document.addEventListener("click", function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    if (t.closest("#perso-atelier-cta")) { e.preventDefault(); ouvrir(); }
  });
  /* Au chargement, puis a chaque pivotement : un telephone tourne en paysage passe la barre des
     900 px, et le bouton doit disparaitre en meme temps que la fenetre cesse d'etre possible. */
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", armeCta);
  else armeCta();
  window.addEventListener("resize", armeCta);

  window.persoAtelier = { ouvrir: ouvrir, fermer: fermer, disponible: disponible,
    armeCta: armeCta, majOnglets: majOnglets };
}());
